import React from "react";
import { Table } from "../../../../v2/design-system";
import { formatDateTime } from "../../../../utils/common";
import { HubViewRowButton } from "../tableShared";

const UsersTable = ({ data, pagination, onUserView }) => {
  const columns = [
    { key: "createdDate", label: "Created Date", align: "left", render: (_, row) => formatDateTime(row?.createdDate) },
    { key: "firstName", label: "First Name", align: "left" },
    { key: "lastName", label: "Last Name", align: "left" },
    { key: "mobileNo", label: "Mobile No.", align: "left" },
    { key: "role", label: "Role", align: "left" },
    {
      key: "status",
      label: "Kyc Status",
      align: "left",
      render: (_, row) => (row?.status ? row.status.toUpperCase() : ""),
    },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <HubViewRowButton
          ariaLabel={`View details for ${row?.firstName ?? "user"}`}
          onClick={() => onUserView(row)}
        />
      ),
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      rowKey="id"
      emptyMessage="No users found"
      pagination={pagination}
    />
  );
};

export default UsersTable;
